import { createContext } from 'react';

export type AccountTransferCtx = {
  showAccountTransferErrorAlert: boolean;
  accountTransferError: string;
};

const AccountTransferDialogueContext = createContext<AccountTransferCtx>({
  showAccountTransferErrorAlert: false,
  accountTransferError: '',
});

export default AccountTransferDialogueContext;